module.exports = __webpack_public_path__ + "img/cancelIcon.aeb124e9.svg";